import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=2c32304f&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32304f",
  null
  
)

export default component.exports